import { DealerCashRuleType } from '@upstart/harmony/lib/constants';
import { PriceRule } from '@upstart/harmony/lib/legos/dealerTypes';
import { isNull } from 'lodash';
import React from 'react';
import { Button } from 'react-bootstrap';

const isNullOrUndefined = (value: number | undefined) =>
  isNull(value) || value === undefined;

function DealerCashModal({
  close,
  open,
  type,
  renderDealerCashRuleInput,
  dealerCashValue,
  setCashValue,
  setPurchaseValue,
  setLeaseValue,
  resetToDefault,
}: {
  close: VoidFunction;
  open?: boolean;
  type: DealerCashRuleType | undefined;
  renderDealerCashRuleInput: Function;
  dealerCashValue: PriceRule;
  setCashValue: Function;
  setPurchaseValue: Function;
  setLeaseValue: Function;
  resetToDefault: Function;
}) {
  if (!open) {
    return <div />;
  }

  const renderDefault = () => {
    if (dealerCashValue?.dealerCashRuleValue) {
      if (type === DealerCashRuleType.PRICE_OFFSET_FIXED_MAX) {
        return (
          <div className="dealer-cash-finance-label">
            Default: ${dealerCashValue?.dealerCashRuleValue}
          </div>
        );
      }
      return (
        <div className="dealer-cash-finance-label">
          Default: {dealerCashValue?.dealerCashRuleValue}%
        </div>
      );
    }
    return <div />;
  };

  return (
    <div
      className="p-modal-container dealer-cash-modal-container"
      onClick={() => close()}
    >
      <div className="dealer-cash-modal-positioner">
        <div className="dealer-cash-modal" onClick={(e) => e.stopPropagation()}>
          <div className="dealer-cash-menu-container">
            <div className="dealer-cash-menu">
              <i onClick={() => close()} className="modal-close close icon" />

              <div>Dealer Cash - Payment Type</div>
              <div>
                <div className="dealer-cash-finance-label">Cash</div>
                {renderDealerCashRuleInput({
                  type,
                  value: isNullOrUndefined(
                    dealerCashValue.dealerCashRuleValueByFinance?.cash,
                  )
                    ? dealerCashValue.dealerCashRuleValue
                    : dealerCashValue.dealerCashRuleValueByFinance?.cash,
                  setValue: setCashValue,
                })}
              </div>
              <div>
                <div className="dealer-cash-finance-label">Finance</div>
                {renderDealerCashRuleInput({
                  type,
                  value: isNullOrUndefined(
                    dealerCashValue.dealerCashRuleValueByFinance?.purchase,
                  )
                    ? dealerCashValue.dealerCashRuleValue
                    : dealerCashValue.dealerCashRuleValueByFinance?.purchase,
                  setValue: setPurchaseValue,
                })}
              </div>
              <div>
                <div className="dealer-cash-finance-label">Lease</div>
                {renderDealerCashRuleInput({
                  type,
                  value: isNullOrUndefined(
                    dealerCashValue.dealerCashRuleValueByFinance?.lease,
                  )
                    ? dealerCashValue.dealerCashRuleValue
                    : dealerCashValue.dealerCashRuleValueByFinance?.lease,
                  setValue: setLeaseValue,
                })}
              </div>
              {renderDefault()}

              <Button
                onClick={() => resetToDefault()}
                className="dealer-cash-reset-button"
              >
                Reset to default
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DealerCashModal;
